import axios from 'axios';

const getLicenses = async ({ labourerId }) => {
  const searchParams = new URLSearchParams();

  if (labourerId) searchParams.append('labourerId', labourerId);

  const params = searchParams.toString();

  const response = await axios.get(`${process.env.REACT_APP_API_URL}/licenses?${params}`);

  return response.data;
}

const getLicense = async (id) => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/licenses/${id}`);

  return response.data;
}

const createLicense = async ({ licenseData }) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/licenses`, licenseData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
}

const updateLicense = async ({ licenseId, licenseData }) => {
  const response = await axios.put(`${process.env.REACT_APP_API_URL}/licenses/${licenseId}`, licenseData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
}

const deleteLicense = async ({ licenseId }) => {
  const response = await axios.delete(`${process.env.REACT_APP_API_URL}/licenses/${licenseId}`);

  return response.data;
}

const licenseService = {
  getLicenses,
  getLicense,
  createLicense,
  updateLicense,
  deleteLicense
}

export default licenseService;
